// Turf.EstimatedMinutes is null until Optimize / route refresh routes the turf — a bare cut
// leaves it null, not 0. Summing nulls as 0 would show "0 min" for an un-routed map.
export function sumEstimatedMinutes(turfs: { estimatedMinutes: number | null }[]): number | null {
  return turfs.some(t => t.estimatedMinutes != null)
    ? turfs.reduce((sum, t) => sum + (t.estimatedMinutes ?? 0), 0)
    : null
}

export function formatEstimatedMinutes(minutes: number | null): string {
  return minutes == null ? '—' : `${minutes.toLocaleString()} min`
}
